import React from "react";
import { css, useTheme } from "@emotion/react";

type Props = {
    children: React.ReactNode,
    type?: string,
};

const HeaderContainer:React.FC<Props> = ({ children, type }) => {
    const theme = useTheme();

    const style = css`
        display: flex;
        justify-content: space-between;
        align-items: center;
        width: 100%;

        ${type === "event" && css`
            ${theme.breakpoints.down("md")} {
                flex-direction: column;
            }
        `}

        ${(type === "success-story" || type === "career") && css`
            ${theme.breakpoints.down("sm")} {
                flex-direction: column;
            }
        `}
    `;

    return (
        <div css={style}>{children}</div>
    );
};

export default HeaderContainer;